import { TFunction } from "i18next";

export const getReadOnlySelectProps = (t: TFunction) => ({
  emptyOption: {
    text: `--${t("common.select")}--`,
    value: undefined,
  },
  onChange: () => {},
  disabled: true,
});
